import { SHARED_DEALS } from '../sharedConfig';

export default {
  key: 'general5k',
  label: 'General Display Strategy - $5K Budget',
  strategySets: {
    default: {
      label: 'Standard (8 items)',
      lineItems: [
        { name: 'CPM_Broad_21+_X_DIS_Prospecting', segment: 'BROAD_21PLUS', budgetAllocation: 30 },
        { name: 'CPM_BT_Cannabis_Interest_WithSegments_DIS_Prospecting', segment: 'CANNABIS_INTEREST', budgetAllocation: 10 },
        { name: 'CPM_BT_Cannabis&THC_Interest_WithSegments_DIS_Prospecting', segment: 'CANNABIS_THC', budgetAllocation: 10 },
        { name: 'CPM_BT_CannabisDeliveryResearchers_KnownResearchers_WithSegments_DIS_Prospecting', segment: 'CANNABIS_DELIVERY', budgetAllocation: 10 },
        { name: 'CPM_BT_DispensaryVisitors_KnownVisitors_WithSegments_DIS_Prospecting', segment: 'DISPENSARY_VISITORS', budgetAllocation: 10 },
        { name: 'CPM_BT_DispensaryResearchers_KnownResearchers_WithSegments_DIS_Prospecting', segment: 'DISPENSARY_RESEARCH', budgetAllocation: 10 },
        { name: 'CPM_BT_CalmGummies_Interest_WithSegments_DIS_Prospecting', segment: 'CALM_GUMMIES', budgetAllocation: 10 },
        { name: 'CPM_BT_HolisticMedicine_Interest_WithSegments_DIS_Prospecting', segment: 'HOLISTIC_MEDICINE', budgetAllocation: 10 },
      ],
    },
  },
  deals: SHARED_DEALS,
};
